var map = {
	"./adjust.svg": 69174,
	"./alarm.svg": 15810,
	"./arrow-down-1.svg": 27281,
	"./arrow-up-down.svg": 50473,
	"./assets.svg": 94220,
	"./attention.svg": 75431,
	"./autolock.svg": 98855,
	"./barter.svg": 26107,
	"./borrow.svg": 28348,
	"./checkmark-circle.svg": 88823,
	"./checkmark.svg": 20106,
	"./chevron-down.svg": 4605,
	"./clippy.svg": 8868,
	"./clock.svg": 80339,
	"./cog.svg": 64588,
	"./cogs.svg": 42535,
	"./coming_soon.svg": 72496,
	"./connect.svg": 94391,
	"./connected.svg": 51684,
	"./create_account.svg": 19223,
	"./cross-circle.svg": 89034,
	"./dashboard.svg": 5997,
	"./delete.svg": 84746,
	"./deployment-unit.svg": 32797,
	"./deposit.svg": 78939,
	"./direct_debit.svg": 92439,
	"./disconnected.svg": 77178,
	"./dollar-green.svg": 59607,
	"./dollar.svg": 40529,
	"./download.svg": 17967,
	"./excel.svg": 69236,
	"./eye-striked.svg": 60199,
	"./eye.svg": 39234,
	"./fi-star.svg": 88717,
	"./filter.svg": 15929,
	"./fire.svg": 21623,
	"./folder.svg": 78467,
	"./grouping.svg": 91528,
	"./hamburger-x.svg": 94451,
	"./hamburger.svg": 25236,
	"./hourglass.svg": 45555,
	"./htlc.svg": 38712,
	"./info-circle-o.svg": 75120,
	"./insight.svg": 2349,
	"./instant-trade.svg": 15879,
	"./key.svg": 86752,
	"./list.svg": 239,
	"./locked.svg": 54069,
	"./merchant.svg": 54467,
	"./minus-circle.svg": 85374,
	"./news.svg": 22702,
	"./paperclip.svg": 36161,
	"./people.svg": 72574,
	"./photo-camera.svg": 20071,
	"./plus-circle.svg": 74144,
	"./poolmart.svg": 72289,
	"./pools.svg": 36100,
	"./power.svg": 25094,
	"./prediction-large.svg": 13182,
	"./prediction.svg": 18704,
	"./qr-scan.svg": 60404,
	"./question-circle.svg": 77688,
	"./question-in-circle.svg": 16438,
	"./server.svg": 2794,
	"./settle.svg": 50274,
	"./share.svg": 40204,
	"./showcases.svg": 47319,
	"./shuffle.svg": 70110,
	"./swap.svg": 67030,
	"./text.svg": 65350,
	"./thumb-tack.svg": 74177,
	"./thumb-untack.svg": 20804,
	"./thumbs-up.svg": 10946,
	"./times.svg": 30019,
	"./trade.svg": 36535,
	"./transfer.svg": 79942,
	"./unlocked.svg": 5536,
	"./user.svg": 72306,
	"./voting.svg": 40150,
	"./wallet.svg": 70088,
	"./warning.svg": 57785,
	"./withdraw.svg": 10537,
	"./zoom.svg": 43578
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82946;